import * as React from "react";
import cn from "classnames";

import { FieldWrapper } from "components/FieldWrapper";

import styles from "./TextArea.module.scss";
import { FieldWrapperProps } from "components/FieldWrapper/FieldWrapper";

export interface TextAreaProps extends React.HTMLProps<HTMLTextAreaElement> {
  icon?: React.ReactNode;
  inputSize?: "small" | "medium";
}

export const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  TextAreaProps & FieldWrapperProps
>(
  (
    { label, icon, error, withError, required, ...props },
    ref
  ) => {
    return (
      <FieldWrapper
        error={error}
        withError={withError}
        label={label}
        required={required}
      >
        <div
          className={cn(
            styles.inputContainer,
            icon ? styles.inputContainer__icon : null
          )}
        >
          <textarea
            ref={ref}
            type="text"
            className={cn(styles.input)}
            {...props}
          />
          {icon ? <div className={styles.icon}>{icon}</div> : null}
        </div>
      </FieldWrapper>
    );
  }
);
